import classNames from 'classnames'
import React from 'react'

import { createStyles } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

const CardFooter: React.SFC<CardFooterPropsWithStyles> = ({ classes, className, children, ...rest }) => {
  const cardFooterClasses = classNames({
    [classes.cardFooter]: true,
    [className]: className !== undefined,
  })
  return (
    <div className={cardFooterClasses} {...rest}>
      {children}
    </div>
  )
}

type CardFooterPropsWithStyles = CardFooterProps & WithStyles<typeof styles>

type CardFooterProps = {
  className: string
}

const styles = () =>
  createStyles({
    cardFooter: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      padding: '0.9375rem 1.875rem',
    },
  })

export default withStyles(styles)(CardFooter)
